import * as processesAbbreviations from 'modules/Abbreviations/processes';
import { selectAbbreviationsData } from 'modules/Abbreviations/store/selectors';
import { call, select } from 'redux-saga/effects';
import * as Models from 'models';
import * as processes from 'services/processes';
import { toJS } from 'utils/immutable';
import { sagaFlow } from 'utils/sagaFlow';
import { getProjectAssets } from './getProjectAssets';

export function* processSyncedAssets(
  documents: Models.CombinedDocuments,
  masterScreenData: Models.MasterScreenData,
  actionsWithMiddleware: Models.IAction[],
  isProjectTranslatable: boolean,
  projectAssets?: Models.ProjectAssetsToUpload,
): Generator<unknown, Models.SyncProcessArgs> {

  const textAbbreviationDocuments: ReturnTypeSaga<typeof selectAbbreviationsData> = yield select(selectAbbreviationsData);
  const textAbbreviationDocumentsArray = textAbbreviationDocuments.toJS() as Models.TextAbbreviationDocumentsArray;

  const projectPrevAssets =
    projectAssets ??
    toJS((yield call(getProjectAssets, { removeInternalInfo: false })) as ReturnTypeSaga<typeof getProjectAssets>);

  const prevAssets: Models.SyncProcessArgs['prevAssets'] = {
    documents: projectPrevAssets.documents,
  };

  const assets: Models.SyncProcessArgs['assets'] = {
    ...projectPrevAssets,
    documents,
    masterScreenData,
  };

  const dataToProcess: Models.SyncProcessArgs = {
    assets,
    prevAssets,
    actionsWithMiddleware,
    isProjectTranslatable,
  };

  const syncedDataProcesses = sagaFlow<Models.SyncProcessArgs>(
    processes.extendReusableLayoutBrandDefinitions,
    data => processes.refreshLayoutsOnArtboards(data, false),
    processes.resetLayoutsWithoutDocument,
    processes.processBackgroundImages,
    processes.getActionsToImagesLoading,
    processes.getActionsToLayoutPreviewsLoading,
    (arg) => {
      arg.assets.documents = processesAbbreviations.removeMissingAbbreviations(arg.assets.documents, textAbbreviationDocumentsArray);

      return arg;
    },
  );

  const processedData: ReturnTypeSaga<typeof syncedDataProcesses> = yield call(syncedDataProcesses, dataToProcess);

  return processedData;
}
